import React from 'react';
import {Box, Heading, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';

import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';
import {DashboardItem} from '../../../../../components/dashboard';
import {PaymentOnLineIcon, PaymentsIcon} from '../../../../../components/icons';
import {message as t} from '../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'FeePaymentOptionScreen'
>;

const FeePaymentOptionScreen = ({navigation}: ScreenProps) => {
  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleGoCreditCardFormScreen = () => {
    navigation.navigate('PaymentCreditCardFormScreen');
  };

  const handleGoC2pScreen = () => {
    navigation.navigate('PaymentC2pFormScreen');
  };

  const handleGoLoadVoucher = () => {
    navigation.navigate('FeePaymentProofScreen');
  };

  return (
    <InternalTemplate
      title={'screen-fee-payment-options-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <VStack space={3} justifyContent="center" marginX={4}>
        <Heading
          color="#06355E"
          fontSize="md"
          fontWeight="medium"
          marginBottom={2}>
          {t('screen-fee-payment-options-header-title')}
        </Heading>
        <DashboardItem
          label="screen-fee-payment-options-pay-online-c2p"
          icon={
            <Box marginTop={2}>
              <PaymentOnLineIcon width={40} />
            </Box>
          }
          shadow={true}
          onPress={handleGoC2pScreen}
        />
        <DashboardItem
          label="screen-fee-payment-options-send-proof"
          icon={
            <Box marginTop={2}>
              <PaymentsIcon width={40} fillColor={'#0088FF'} />
            </Box>
          }
          shadow={true}
          onPress={handleGoLoadVoucher}
        />
        <DashboardItem
          label="screen-fee-payment-options-pay-online-credit-card"
          icon={
            <Box marginTop={2}>
              <PaymentOnLineIcon width={40} />
            </Box>
          }
          shadow={true}
          onPress={handleGoCreditCardFormScreen}
        />
      </VStack>
    </InternalTemplate>
  );
};
export {FeePaymentOptionScreen};
